import Modal from "react-bootstrap/Modal";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  TONES,
  sevenToneScale,
  eightToneScale,
  sixToneScale,
  fiveToneScale,
  otherToneScales,
} from "../../helpers/pianoHelpers";
import {
  setCurrentSongIndex,
  setGhostTonesMT,
  setSongsArray,
  setTonesMT,
} from "../../store/actions";
import { note } from "../../helpers/keyLabelsMapper";
class PopupMusicTheorySong extends Component {
  state = {
    modesOfScales: "",
    TONES: TONES,
    sevenToneScale: sevenToneScale,
    eightToneScale: eightToneScale,
    sixToneScale: sixToneScale,
    fiveToneScale: fiveToneScale,
    otherToneScales: otherToneScales,
    note: "C",
  };

  componentWillMount() {
    // let selectedNotes = this.props.tonesMT;
    let selectedNotes = this.props.editFormula || { tones: 0 };
    if (selectedNotes.tones === 0) {
      // pentatonic
      this.setState({ modesOfScales: "fiveToneScale" });
    } else if (selectedNotes.tones === 1) {
      // 6 tones
      this.setState({ modesOfScales: "sixToneScale" });
    } else if (selectedNotes.tones === 2) {
      // 7 tones
      this.setState({ modesOfScales: "sevenToneScale" });
    } else if (selectedNotes.tones === 3) {
      // 8 tones
      this.setState({ modesOfScales: "eightToneScale" });
    } else if (selectedNotes.tones === 4) {
      // other tones
      this.setState({ modesOfScales: "otherToneScale" });
    }
  }

  componentDidMount() {
    if (this.props.editFormula) {
      this.setState({
        note: this.props.NOTES[this.props.editFormula.baseNote],
      });
    }
  }
  // const OCTAVES = [2, 3, 4, 5, 6];

  submitTones = (event) => {
    event.preventDefault();
    let data = {};

    const {
      NOTES,
      songsArray,
      currentSongName,
      currentSectionName,
      tonesMT,
      currentSongIndex,
      editFormulaIndex,
    } = this.props;

    // Calculate indices
    let baseNote = this.state.note;
    let indexBaseNote = NOTES.findIndex((x) => x === baseNote);
    data.baseNote = indexBaseNote;

    let tones = document.getElementById("tones").value;
    let indexTones = this.state.TONES.findIndex((x) => x === tones);
    data.tones = indexTones;
    data.note = baseNote;
    let modesOfS = document.getElementById("modesOfScales").value;
    let indexModeOfScale = this.state[`${this.state.modesOfScales}`].findIndex(
      (x) => {
        let valueToCompare = !x.secondDegree
          ? `${x.name} ${x.degree || ""} ${x.name2 ? x.name2 : ""}`
          : `${x.name} ${x.degree || ""} ${x.name2 ? x.name2 : ""} ${
              x.secondDegree
            }`;

        return valueToCompare === modesOfS;
      }
    );

    data.modesOfScales = indexModeOfScale;
    data.modesOfScalesValues =
      this.state[`${this.state.modesOfScales}`][indexModeOfScale];

    if (tones && modesOfS) {
      let updatedArray = { ...songsArray };

      if (editFormulaIndex === "") {
        // Handling insertion
        if (currentSongIndex !== "") {
          let targetSectionName = currentSectionName;
          const updatedSectionArray = [
            ...(songsArray[currentSongName][targetSectionName] || []),
          ];

          if (currentSongIndex !== undefined && currentSongIndex !== null) {
            // Insert after the currently selected formula
            updatedSectionArray.splice(currentSongIndex + 1, 0, data);
          } else {
            // Append to the end if no formula is selected
            updatedSectionArray.push(data);
          }

          // Update the songs array
          updatedArray = {
            ...songsArray,
            [currentSongName]: {
              ...songsArray[currentSongName],
              [targetSectionName]: updatedSectionArray,
            },
          };
          this.props.setCurrentSongIndex(this.props.currentSongIndex + 1);
        } else {
          updatedArray[currentSongName][currentSectionName].push(data);

          const ghostSong =
            updatedArray[currentSongName][currentSectionName][
              currentSongIndex + 1
            ] || updatedArray[currentSongName][currentSectionName][0];

          this.props.setGhostTonesMT(ghostSong);
        }
      } else {
        // Handling updates
        updatedArray[currentSongName][currentSectionName][editFormulaIndex] =
          data;

        if (editFormulaIndex === currentSongIndex) {
          this.props.setTonesMT(data);
        }

        if (editFormulaIndex === currentSongIndex + 1) {
          this.props.setGhostTonesMT(
            updatedArray[currentSongName][currentSectionName][
              currentSongIndex + 1
            ]
          );
        }
      }

      // Apply changes to the songs array
      this.props.setSongsArray(updatedArray);
      this.props.toggleModal();
    } else {
      // Close modal if input is invalid
      this.props.toggleModal();
    }
  };

  toneChanged = () => {
    let tones = document.getElementById("tones").value;

    if (tones === "Tonal Scales and Modes") {
      // 7 tones
      this.setState({ modesOfScales: "sevenToneScale" });
    } else if (tones === "Pentatonic Scale") {
      // pentatonic
      this.setState({ modesOfScales: "fiveToneScale" });
    } else if (tones === "Hexaphonic Scales") {
      // 6 tones
      this.setState({ modesOfScales: "sixToneScale" });
    } else if (tones === "Octophonic scales") {
      // 8 tones
      this.setState({ modesOfScales: "eightToneScale" });
    } else if (tones === "Other Scales") {
      // other tones
      this.setState({ modesOfScales: "otherToneScales" });
    }
  };
  render() {
    let allScaleObj = {
      sevenToneScale: this.state.sevenToneScale,
      fiveToneScale: this.state.fiveToneScale,
      sixToneScale: this.state.sixToneScale,
      eightToneScale: this.state.eightToneScale,
      otherToneScales: this.state.otherToneScales,
    };
    return (
      <div>
        <Modal
          size="lg"
          show={this.props.show}
          onHide={() => this.props.toggleModal()}
          aria-labelledby="vocal-range-popup"
        >
          <Modal.Header closeButton>
            <Modal.Title id="vocal-range-popup">
              Add Mode To Your Song
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div>
                <div className="row">
                  <div className="form-group col-12">
                    <label className="form-label" htmlFor="baseNote">
                      Root
                    </label>
                    <select
                      id="baseNote"
                      className="form-control form-control-lg"
                      defaultValue={
                        !this.props.editFormula
                          ? this.props.NOTES[3]
                          : this.props.NOTES[this.props.editFormula.baseNote]
                      }
                      onChange={(e) => this.setState({ note: e.target.value })}
                    >
                      {this.props.NOTES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-12">
                    <label className="form-label" htmlFor="tones">
                      Scale
                    </label>
                    <select
                      id="tones"
                      className="form-control form-control-lg"
                      onChange={(event) => this.toneChanged(event)}
                      defaultValue={
                        !this.props.editFormula
                          ? this.state.TONES[0]
                          : this.state.TONES[this.props.editFormula.tones]
                      }
                    >
                      {this.state.TONES.map((item) => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-12 mb-2">
                    <label className="form-label" htmlFor="modesOfScales">
                      Mode
                    </label>
                    <select
                      id="modesOfScales"
                      className="form-control form-control-lg"
                      defaultValue={
                        this.props.editFormula
                          ? `${
                              this.props.editFormula?.modesOfScalesValues.name
                            } ${
                              this.props.editFormula.modesOfScalesValues
                                .degree || ""
                            } ${
                              this.props.editFormula?.modesOfScalesValues
                                .name2 || ""
                            } ${
                              this.props.editFormula.modesOfScalesValues
                                .secondDegree || ""
                            }`
                          : allScaleObj[this.state.modesOfScales][0]
                      }
                    >
                      {allScaleObj[this.state.modesOfScales].map(
                        (item, index) => (
                          <React.Fragment
                            key={`${item.name}${item.x}${item.y}`}
                          >
                            {/* Additional non-selectable categories based on 'y' */}
                            {this.state.modesOfScales === "sevenToneScale" && (
                              <>
                                {item.y === 0 && item.x === 0 && (
                                  <optgroup label="Major Melodic"></optgroup>
                                )}
                                {item.y === 1 && item.x === 0 && (
                                  <optgroup label="Major Harmonic"></optgroup>
                                )}
                                {item.y === 2 && item.x === 0 && (
                                  <optgroup label="Minor Harmonic"></optgroup>
                                )}
                                {item.y === 3 && item.x === 0 && (
                                  <optgroup label="Minor Melodic"></optgroup>
                                )}
                              </>
                            )}

                            {/* Regular options based on item values */}
                            <option
                              value={
                                !item.secondDegree
                                  ? `${item.name} ${item.degree || ""} ${
                                      item.name2 ? item.name2 : ""
                                    }`
                                  : `${item.name} ${item.degree || ""} ${
                                      item.name2 ? item.name2 : ""
                                    } ${item.secondDegree}`
                              }
                            >
                              {!item.secondDegree
                                ? `${item.name} ${item.degree || ""} ${
                                    item.name2 ? item.name2 : ""
                                  }`
                                : `${item.name} ${item.degree || ""} ${
                                    item.name2 ? item.name2 : ""
                                  } ${item.secondDegree}`}
                            </option>
                          </React.Fragment>
                        )
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <button
                className="btn btn_primary btn-lg"
                onClick={(event) => this.submitTones(event)}
              >
                Apply Changes
              </button>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    NOTES: state.notes,
    songsArray: state.songsArray,
    currentSongIndex: state.currentSongIndex,
    currentSongName: state.currentSongName,
    currentSectionName: state.currentSectionName,
  };
};

const mapDispatchToProps = {
  setSongsArray,
  setGhostTonesMT,
  setTonesMT,
  setCurrentSongIndex,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopupMusicTheorySong);
// export default PopupMusicTheory;
